// extracted by mini-css-extract-plugin
export default {"orderDetailsInfo":"OrderDetailsInfo_orderDetailsInfo__DGBEF"};